import React, { useEffect, useState } from "react";
import { IAccessCredentialListItem } from "api/entities/access-credential";
import { IPage } from "api/entities/page";
import { accessCredentialsService } from "api/services/application-service";
import { getEmptyPage } from "redux/reducers/entity";
import { useApi } from "utils/hooks/use-api";
import FormSection from "components/shared-ui/form/form-section/form-section";

export interface IBucketUsedBySectionProps {
    bucketId?: string;
}

export function BucketUsedBySection(props: IBucketUsedBySectionProps) {
    const { bucketId } = props;
    const [api] = useApi();
    const [page, setPage] = useState<IPage<IAccessCredentialListItem>>(getEmptyPage());

    function getApplicationCredentials() {
        return page && page.count > 0 && page.data.map((x, idx) => <div key={`access-credential--${idx}`}>{x.name}</div>);
    }

    useEffect(() => {
        if (bucketId) {
            api(accessCredentialsService.getPage({ bucket: bucketId })).then(setPage);
        }
        // eslint-disable-next-line
    }, [bucketId]);
    return (
        <>
            {
                bucketId && page.count > 0 &&
                <FormSection testId="used-by-section" title="Used By">
                    {getApplicationCredentials()}
                </FormSection>
            }
        </>
    );
}
